import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SharedModule } from '@shared/shared.module';

import { ProductImportImagesComponent } from './components/product-import-images/product-import-images.component';
import { ProductImportTableCheckerComponent } from './components/product-import-table-checker/product-import-table-checker.component';
import { ProductImportComponent } from './containers/product-import/product-import.component';
import { ProductImportRoutingModule } from './product-import-routing.module';
import { ProductImportImagesEffects } from './store/product-import.effects';
import { ProductImportFeature } from './store/product-import.slice';

@NgModule({
  declarations: [
    ProductImportComponent,
    ProductImportImagesComponent,
    ProductImportTableCheckerComponent,
  ],
  imports: [
    CommonModule,
    ProductImportRoutingModule,
    StoreModule.forFeature(ProductImportFeature),
    EffectsModule.forFeature([ProductImportImagesEffects]),
    SharedModule,
  ],
})
export class ProductImportModule {}
